// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import { pixelToEm } from '../../utils/common';

const Wrapper = styled.div`
  color: ${theme.Scoreboards.psoScoreColor};
  background: ${theme.Scoreboards.psoScoreBackground};
  border-radius: 5px;
  padding: 0.2em 0.4em;

  font-size: ${pixelToEm(10.4)}em;
  font-weight: 500;
  letter-spacing: 0.05em;
  white-space: nowrap;
`;

type ScoreboardPsoScoreProps = {
  className?: string;
  score1: string;
  score2: string;
};

const ScoreboardPsoScore = ({ className, score1, score2 }: ScoreboardPsoScoreProps) => {
  return (
    <Wrapper className={className}>
      {__('!short:PenaltyShootOut')} : {score1} - {score2}
    </Wrapper>
  );
};

export default ScoreboardPsoScore;
